import { render, staticRenderFns } from "./dui-option-picker.vue?vue&type=template&id=cb3154d8&scoped=true&"
import script from "./dui-option-picker.vue?vue&type=script&lang=js&"
export * from "./dui-option-picker.vue?vue&type=script&lang=js&"
import style0 from "./dui-option-picker.vue?vue&type=style&index=0&id=cb3154d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3154d8",
  null
  
)

export default component.exports